export default function BacktestConfigMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-body">
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-heading"><span className="chevron">&#9662;</span> MARKET</div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Mode</span>
            <span className="mock-toggle"><span className="mock-toggle-opt active">Single</span><span className="mock-toggle-opt">Baseline</span></span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Symbol</span>
            <span className="mock-sidebar-val">BTCUSDT <span className="mock-sidebar-link">Change</span></span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Interval</span>
            <span className="mock-sidebar-val">1 Day <span className="mock-sidebar-link">Change</span></span>
          </div>
        </div>
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-heading"><span className="chevron">&#9662;</span> DATA RANGE</div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Mode</span>
            <span className="mock-toggle"><span className="mock-toggle-opt">Date</span><span className="mock-toggle-opt active">Candle</span></span>
          </div>
          <div className="mock-subtitle-hint">Evaluate a fixed sample size</div>
          <div className="mock-range-track">
            <div className="mock-range-fill" style={{ width: '99.7%' }} />
            <div className="mock-range-thumb" style={{ left: '99.7%' }} />
          </div>
          <div className="mock-range-labels"><span>Candle 1</span><span>Candle 3,140</span></div>
          <div className="mock-range-dates"><span>Aug 17, 17</span><span>Mar 19, 26</span></div>
          <div className="mock-range-summary">
            <span style={{ color: '#6b7280' }}>3,148 total</span>
            <span style={{ color: '#9d4edd', fontWeight: 700 }}>3,140 selected</span>
          </div>
          <div className="mock-presets">
            <span className="mock-preset-chip">500</span>
            <span className="mock-preset-chip">1k</span>
            <span className="mock-preset-chip">2k</span>
            <span className="mock-preset-chip">5k</span>
            <span className="mock-preset-chip">All</span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">Configure market, timeframe, and data range before running a backtest.</div>
    </div>
  );
}
